var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3A200037-97C0-4795-B517-E84DBCD48208@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Atlm-krosmarks",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1297.000000, -3318.000000)",
    fill: "#0061ED",
    id: "faq_off_blue-copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1297.000000, 3318.000000)",
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 5,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    transform: "translate(6.000000, 6.000000) rotate(-270.000000) translate(-6.000000, -6.000000) ",
    x: 0,
    y: 5,
    width: 12,
    height: 2
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionPlus);
export default ForwardRef;